import { enumOrderValidator } from '@/shared/model/order';

export type ConfigMode = 'estimate' | 'cart';

export type OrderService = {
  id: number;
  price: number;
  label: string;
};

export type VoucherStatus = 'NotFound' | 'AlreadyUsed' | 'RequireAuthentication' | 'Valid';

export type OrderVoucher = {
  code: string;
  status: VoucherStatus;
  discount?: number;
};

export type OrderSummary = {
  base: number;
  total: number;
  durationInDays: number;
  localPrice?: number;
  priceSaved?: number;
  timeSaved: number;
  services: Array<OrderService>;
  siteSwitch?: number;
  voucher?: OrderVoucher;
  hasBasicOption: boolean;
  hasCancellationOption: boolean;
  isCancellationOptionFree: boolean;
  isAnyInsuranceAvailable: boolean;
  totalBasic: number;
  totalWithCancellation: number;
  valetDiscount?: number;
  isDiscountSitePromotion: boolean;
  baseWithoutDiscount: number;
  cancellationOptionId: number;
};

export interface BusinessCompany {
  businessCustomerId: number;
  businessId: number;
  businessName: string;
  isWorker: boolean;
  workerName: string | null;
}

export type BusinessWorker = {
  id: string;
  business: string;
  name: string;
  isWorker?: boolean;
};

export const OptionTypes = {
  basic: 'basic',
  premium: 'premium',
};

export const TravelTypes = {
  perso: 'personal',
  pro: 'professional',
  bvb: 'bluevaletbusiness',
};

export enum StepType {
  booking = 'BOOKING',
  services = 'SERVICES',
  options = 'OPTIONS',
  information = 'INFORMATION',
}

export const stepTypeHref: Record<StepType, string> = {
  [StepType.booking]: '/?keep=true',
  [StepType.services]: '/cart/services',
  [StepType.options]: '/cart/options',
  [StepType.information]: '/cart/info',
};

export const stepTypeOrder = enumOrderValidator<StepType>()(
  StepType.booking,
  StepType.services,
  StepType.options,
  StepType.information,
);

export type UserInformation = {
  lastName?: string;
  firstName?: string;
  email?: string;
  phoneNumber?: string;
  company?: string;
  address: {
    firstLine?: string;
    secondLine?: string;
    zipCode?: string;
    city?: string;
    country?: string;
  };
  vehicle: {
    kind?: string;
    color?: string;
  };
  expensesTitle?: string;
};
